import React from 'react';
import { StyledTextField } from '../../../../healtheraComponents';
import { TextFieldProps } from '@material-ui/core/TextField';

const NumberInput = (props: TextFieldProps) => {
  return (
    <StyledTextField
      value={props.value || 0}
      type="number"
      {...props}
    />
  );
};

export default NumberInput;
